import {DealOriginDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_CUSTOMER_CATEGORY';

export async function createDealOrigin(
    userData: Record<string, string>,
    dealOrigin: Record<string, any>
) {
    try {
        const result = await DealOriginDao.createDealOrigin(userData.userToken, dealOrigin);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
